import React from 'react';

import { ThemeColor, themeColors, ThemeContext } from '@neptune/shared/venus-domain';

export function useThemeColors(): ThemeColor {
  const themeContext = React.useContext(ThemeContext);

  if (!themeContext) {
    throw new Error('useThemeColors must be used within a ThemeProvider or RootThemeProvider');
  }

  return themeColors[themeContext.theme];
}
